import {CachePresenze} from "@commons/mapping/CachePresenze";
import {
    getTabellaArrotondamento,
    getTabellaFasceOrarie,
    getTurno,
    listAccumuli,
    listGiustificativi,
    listGiustificativiXStatus,
    listRangeArrotondamenti,
    listValoriTabellaAzienda
} from "@commons/services/presenze_api/tabelleAzienda.api";

import {
    getCalendarioChiusure,
    getTabellaFlex,
    getTabellaQualificazioneEccedenze,
    getTabellaQuantificazioneEccedenze,
    getTabellaTolleranza,
    listRegoleTabellaGiustAuto,
    listTurniXTabellaAlternativi
} from "@commons/services/presenze_api/tabellePresenze.api";

import {GiustificativoRecord, IdTabellaGenericaAzienda} from "@commons/mapping/GiustificativoRecord";
import {CentroDiCostoRecord} from "@commons/mapping/CentroDiCostoRecord";
import {listTerminali} from "@commons/services/presenze_api/terminaliAzienda.api";
import {getImpiantoWF, listCausaliWF} from "@commons/services/presenze_api/workflow.api";
import {StatusRecord} from "@commons/mapping/StatusRecord";
import {TurnoRecord} from "@commons/mapping/TurnoRecord";
import {TabellaArrotondamentiRecord} from "@commons/mapping/TabellaArrotondamentiRecord";
import {TurnoDistribuzioneRecord} from "@commons/mapping/TurnoDistribuzioneRecord";
import {TabellaGiustAutoRecord} from "@commons/mapping/TabellaGiustAutoRecord";
import {FlexRecord} from "@commons/mapping/FlexRecord";
import {TabellaAlternativiRecord} from "@commons/mapping/TabellaAlternativiRecord";
import {LavoratorePresenzeProprietaULRecord} from "@commons/mapping/LavoratorePresenzeProprietaULRecord";
import {TabelleInCaricamento} from "@commons/services/presenze_calcolo/TabelleInCaricamento";
import {GiustAutoXTabellaRecord} from "@commons/mapping/GiustAutoXTabellaRecord";

const isDevelopment = () => (process.env.NODE_ENV === 'development');

type TabelleWFParams = {
    idDominio: number,
    idTabella: number,
    token?: string,
}


const caches: CachePresenze[] = [];
export const invalidateCache = (idAziendaTabelle?: number) => CachePresenze.setStale(caches, idAziendaTabelle);

export function Loader(token?: string) {
    const showLog = isDevelopment();
    const showError = (error: any) => console.log("ERRORE" + JSON.stringify(error));

    const getCache = (idAziendaTabelle: number) => caches.find(c => c.idAziendaTabelle === idAziendaTabelle);

    const purgeCache = (idAziendaTabelle: number) => {
        const cache = getCache(idAziendaTabelle);
        if (cache) {
            // Rimuovo cache
            showLog && console.log('Rimuovo cache per azienda:', idAziendaTabelle);
            const index = caches.indexOf(cache, 0);
            caches.splice(index, 1);
        }
    };

    const initCache = (idDominio: number, idAziendaTabelle: number, idTabellaWF: number): Promise<CachePresenze> => {
        let cache = getCache(idAziendaTabelle);
        if (!cache) {
            cache = new CachePresenze(idDominio, idAziendaTabelle, idTabellaWF);
            caches.push(cache);
        }
        cache.turni = [];
        cache.turniAlternativi = [];
        cache.arrotondamenti = [];
        cache.tabelleFlex = [];
        cache.tabelleTolleranza = [];
        cache.tabelleQuantificaEcc = [];
        cache.tabelleQualificaEcc = [];
        cache.tabelleGiustificazioneAuto = [];
        cache.tabelleFasceOrarie = [];
        cache.tabelleStatus = [];
        cache.gruppiEventi = {};
        cache.tabellaWF = null;
        cache.causaliWF = [];
        cache.accumuliCHK = [];
        cache.terminali = [];
        cache.calendari = [];
        cache.elencoGiustificativi = [];
        cache.elencoUnitaLocali = [];

        const requests: Promise<any>[] = [];
        requests.push(loadAccumuliCHKAzienda(cache));
        requests.push(loadGiustificativiAzienda(cache));
        requests.push(loadTerminali(cache));
        if (idDominio && idTabellaWF) {
            requests.push(loadTabellaWF(cache));
            requests.push(loadCausaliWF(cache));
        } else {
            cache.tabellaWF = null;
            cache.causaliWF = [];
        }
        return Promise.all(requests).then(() => cache!);
    };

    const loadAccumuliCHKAzienda = function (cache: CachePresenze) {
        showLog && console.log("loadAccumuliCHKAzienda INIZIO");
        cache.accumuliCHK = [];
        return listAccumuli({idAziendaTabelle: cache.idAziendaTabelle, token}).then(
            function (data) {
                showLog && console.log("loadAccumuliCHKAzienda FINE");
                cache.accumuliCHK = data;
            },
            (error) => showError(error));
    };

    const loadValoriEventi = function (cache: CachePresenze, idTabella: IdTabellaGenericaAzienda) {
        showLog && console.log("loadValoriEventi INIZIO");
        return listValoriTabellaAzienda({idAziendaTabelle: cache.idAziendaTabelle, idTabella, view: "Grid", token}).then(
            function (data) {
                showLog && console.log("loadValoriEventi FINE");
                cache.gruppiEventi[idTabella] = data;
            },
            (error) => showError(error));
    };

    const loadGiustificativiAzienda = function (cache: CachePresenze) {
        showLog && console.log("loadGiustificativiAzienda INIZIO");
        cache.gruppiEventi = {};

        return listGiustificativi({idAziendaTabelle: cache.idAziendaTabelle, view: "FullEStatus", token}).then(
            (data) => {
                showLog && console.log("loadGiustificativiAzienda FINE");
                cache.elencoGiustificativi = data;

                for (let ind0 = 0; ind0 < cache.elencoGiustificativi.length; ++ind0) {
                    const giu = cache.elencoGiustificativi[ind0];
                    if (giu.idGruppoValori && (GiustificativoRecord.getTipoGiu(giu) === "EVENTO" || giu.specificaValore)) {
                        const tabella: IdTabellaGenericaAzienda = giu.idGruppoValori;
                        cache.gruppiEventi[tabella] = [] as CentroDiCostoRecord[];
                    }
                }
                let prop: IdTabellaGenericaAzienda;
                for (prop in cache.gruppiEventi) {
                    loadValoriEventi(cache, prop);
                }
            },
            (error) => showError(error));
    };

    const loadTerminali = function (cache: CachePresenze) {
        showLog && console.log("loadTerminali INIZIO");
        cache.terminali = [];
        return listTerminali({idAziendaTabelle: cache.idAziendaTabelle, token}).then(
            function (data) {
                showLog && console.log("loadTerminali FINE");
                cache.terminali = data;
            },
            (error) => showError(error));
    };

    const loadTabellaWF = function (cache: CachePresenze) {
        const tabellaCausaliWFParams: TabelleWFParams = {
            idDominio: cache.idDominio,
            idTabella: cache.idTabellaWF,
            token,
        };
        showLog && console.log("loadTabellaWF INIZIO");
        cache.tabellaWF = null;
        return getImpiantoWF(tabellaCausaliWFParams).then(
            function (data) {
                showLog && console.log("loadCausaliWF FINE");
                cache.tabellaWF = data;
            },
            (error) => showError(error));
    };

    const loadCausaliWF = function (cache: CachePresenze) {
        const tabellaCausaliWFParams: TabelleWFParams = {
            idDominio: cache.idDominio,
            idTabella: cache.idTabellaWF,
            token,
        };
        showLog && console.log("loadCausaliWF INIZIO");
        cache.causaliWF = [];
        return listCausaliWF(tabellaCausaliWFParams).then(
            function (data) {
                showLog && console.log("loadCausaliWF FINE");
                cache.causaliWF = data;
            },
            (error) => showError(error));
    };

    const loadGiustificativiXStatus = (idAziendaTabelle: number, codStatus: string): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            const cache = getCache(idAziendaTabelle);
            if (!cache || !codStatus) {
                resolve();
            } else if (cache.getGiustificativiXStatus(codStatus)) {
                resolve();
            } else {
                showLog && console.log("loadGiustificativiXStatus INIZIO");
                listGiustificativiXStatus({idAziendaTabelle, idTabella: "STATUS", codiceElemento: codStatus, token,}).then(
                    (data) => {
                        showLog && console.log("loadGiustificativiXStatus FINE");
                        const tabella = StatusRecord.factory({idAzienda: idAziendaTabelle, id: codStatus});
                        tabella.giustificativi = data;
                        cache.tabelleStatus.push(tabella);
                        resolve();
                    },
                    (err) => {
                        showError(err);
                        reject(err);
                    });
            }
        });
    };

    function caricaTabellaArrotondamenti(cache: CachePresenze, requests: Promise<void>[], idTabella: number) {

        showLog && console.log("caricaTabellaArrotondamenti INIZIO");
        const json = {idArrotondamenti: idTabella};
        const tabella = TabellaArrotondamentiRecord.factory(json);
        cache.arrotondamenti.push(tabella);
        requests.push(getTabellaArrotondamento({idAziendaTabelle: cache.idAziendaTabelle, idArrotondamenti: idTabella, token,}).then(
            function (data) {
                const tabella = cache.getTabellaArrotondamenti(data.idArrotondamenti);
                if (tabella) {
                    showLog && console.log("caricaTabellaArrotondamenti - tabella - FINE");
                    tabella.descrizione = data.descrizione;
                    tabella.arrotondaOrdinarie = data.arrotondaOrdinarie;
                } else throw new Error(`Tabella arrotondamenti #${data.idArrotondamenti} non trovata!`); // N.B. non dovrebbe mai succedere!
            },
            showError)
        );
        requests.push(listRangeArrotondamenti({idAziendaTabelle: cache.idAziendaTabelle, idArrotondamenti: idTabella, token,}).then(
            function (data) {
                if (data.length > 0) {
                    const tabella = cache.getTabellaArrotondamenti(data[0].idArrotondamenti);
                    if (tabella) {
                        showLog && console.log("caricaTabellaArrotondamenti - range - FINE");
                        tabella.ranges = data;
                    } else throw new Error(`Tabella arrotondamenti #${data[0].idArrotondamenti} non trovata!`); // N.B. non dovrebbe mai succedere!
                }
            },
            showError)
        );
    }

    const loadArrotondamenti = function (cache: CachePresenze, turno: TurnoRecord) {
        return new Promise<void>((resolve, reject) => {
            const requests: Promise<void>[] = [];

            for (let indGiorno = 0; indGiorno < turno.distribuzione.length; ++indGiorno) {
                // Carico tabella arrotondamenti timbrature ordinarie
                if (TurnoDistribuzioneRecord.isArrotondamentoDaTabella(turno.distribuzione[indGiorno])) {
                    const idTabella = turno.distribuzione[indGiorno].idTabArrotondamenti;
                    if (idTabella > 0) {
                        if (cache.getTabellaArrotondamenti(idTabella) === null) {
                            caricaTabellaArrotondamenti(cache, requests, idTabella);
                        }
                    }
                }

                // Carico tabella arrotondamenti timbrature ultima uscita
                if (TurnoDistribuzioneRecord.isArrotondamentoUscitaDaTabella(turno.distribuzione[indGiorno])) {
                    const idTabellaUscita = turno.distribuzione[indGiorno].idTabArrotondamentiUscita;
                    if (idTabellaUscita > 0) {
                        if (cache.getTabellaArrotondamenti(idTabellaUscita) === null) {
                            caricaTabellaArrotondamenti(cache, requests, idTabellaUscita);
                        }
                    }
                }

                // Carico tabella arrotondamenti timbrature pausa
                if (TurnoDistribuzioneRecord.isArrotondamentoPausaDaTabella(turno.distribuzione[indGiorno])) {
                    const idTabellaPausa = turno.distribuzione[indGiorno].idTabArrotondamentiPausa;
                    if (idTabellaPausa > 0) {
                        if (cache.getTabellaArrotondamenti(idTabellaPausa) === null) {
                            caricaTabellaArrotondamenti(cache, requests, idTabellaPausa);
                        }
                    }
                }
            }

            if (requests.length > 0) {
                Promise.all(requests).then(
                    () => resolve(),
                    (err) => reject(err)
                );
            } else {
                resolve();
            }
        });
    };

    const loadQualificaEcc = (cache: CachePresenze, idTabella: number): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            if (idTabella === null || idTabella === 0) {
                resolve();
            } else if (cache.getTabellaQualificaEcc(idTabella)) {
                resolve();
            } else {
                showLog && console.log("loadQualificaEcc INIZIO");
                getTabellaQualificazioneEccedenze({idAziendaTabelle: cache.idAziendaTabelle, idTabella, token,}).then(
                    (data) => {
                        showLog && console.log("loadQualificaEcc FINE");
                        cache.tabelleQualificaEcc.push(data);
                        resolve();
                    },
                    (err) => {
                        showError(err);
                        reject(err);
                    });
            }
        });
    };

    const loadQuantificaEcc = (cache: CachePresenze, idTabella: number): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            if (idTabella === null || idTabella === 0) {
                resolve();
            } else if (cache.getTabellaQuantificaEcc(idTabella)) {
                resolve();
            } else {
                showLog && console.log("loadQuantificaEcc INIZO");
                getTabellaQuantificazioneEccedenze({idAziendaTabelle: cache.idAziendaTabelle, idTabella, token,}).then(
                    (data) => {
                        showLog && console.log("loadQuantificaEcc FINE");
                        cache.tabelleQuantificaEcc.push(data);
                        resolve();
                    },
                    (err) => {
                        showError(err);
                        reject(err);
                    });
            }
        });
    };

    const loadTurniAlternativi = (cache: CachePresenze, idTabella: number): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            if (idTabella === null || idTabella === 0) {
                resolve();
            } else if (cache.getTurniAlternativi(idTabella)) {
                resolve();
            } else {
                showLog && console.log("loadTurniAlternativi INIZO");
                const json = {idAziendaTabelle: cache.idAziendaTabelle, idTabella, token,};
                listTurniXTabellaAlternativi(json).then(
                    (data) => {

                        const tabella = TabellaAlternativiRecord.factory(json);
                        tabella.turniAlternativi = data;

                        const requests: Promise<void>[] = [];
                        for (let ind0 = 0; ind0 < tabella.turniAlternativi.length; ++ind0) {
                            requests.push(loadTurno(cache.idAziendaTabelle, tabella.turniAlternativi[ind0].distribuzione.codTurno));
                        }

                        if (requests.length > 0) {
                            Promise.all(requests).then(
                                function () {
                                    showLog && console.log("loadTurniAlternativi FINE");
                                    cache.turniAlternativi.push(tabella);
                                    resolve();
                                }
                            );
                        } else {
                            // Attenzione: è stata specificata una tabella turni alternativi VUOTA!
                            console.warn("Attenzione: è stata specificata una tabella turni alternativi VUOTA! Vedi tabella: " + idTabella);
                            resolve();
                        }
                    },
                    (err) => {
                        showError(err);
                        reject(err);
                    });
            }
        });
    };

    const loadTabellaGiustificazioneAuto = (cache: CachePresenze, idTabella: number): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            if (idTabella === null || idTabella === 0) {
                resolve();
            } else if (cache.getTabellaGiustificazioneAuto(idTabella)) {
                resolve();
            } else {
                showLog && console.log("loadTabellaGiustificazioneAuto INIZIO");
                listRegoleTabellaGiustAuto({idAziendaTabelle: cache.idAziendaTabelle, idTabella, token,}).then(
                    (data: GiustAutoXTabellaRecord[]) => {
                        if (data.length > 0) {
                            const tabellaGiustAuto = TabellaGiustAutoRecord.factory({
                                idTabella: idTabella,
                                descrizione: data[0].descrizione,
                                regole: []
                            });
                            for (let ind0 = 0; ind0 < data.length; ++ind0) {
                                tabellaGiustAuto.regole.push(data[ind0].regola);
                            }
                            cache.tabelleGiustificazioneAuto.push(tabellaGiustAuto);
                        }
                        showLog && console.log("loadTabellaGiustificazioneAuto FINE");
                        resolve();
                    },
                    (err) => {
                        showError(err);
                        reject(err);
                    });
            }
        });
    };

    const loadFlex = (cache: CachePresenze, idTabella: number): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            if (idTabella === null || idTabella === 0) {
                resolve();
            } else if (cache.getTabellaFlex(idTabella)) {
                resolve();
            } else {
                showLog && console.log("loadFlex INIZIO");
                getTabellaFlex({idAziendaTabelle: cache.idAziendaTabelle, idTabella, token,}).then(
                    (data) => {
                        cache.tabelleFlex.push(data);
                        loadArrotondamenti4Flex(cache, data).then(function () {
                            showLog && console.log("loadFlex FINE");
                            resolve();
                        });
                    },
                    (err) => {
                        showError(err);
                        reject(err);
                    });
            }
        });
    };

    const loadArrotondamenti4Flex = (cache: CachePresenze, flex: FlexRecord) => {
        return new Promise<void>((resolve, reject) => {
            const requests: Promise<void>[] = [];

            // Carico tabella arrotondamenti x flex
            if (FlexRecord.isArrotondamentoDaTabella(flex)) {
                const idTabellaFlex = flex.idTabArrotondamenti;
                if (idTabellaFlex > 0) {
                    if (cache.getTabellaArrotondamenti(idTabellaFlex) === null) {
                        caricaTabellaArrotondamenti(cache, requests, idTabellaFlex);
                    }
                }
            }

            if (requests.length > 0) {
                Promise.all(requests).then(
                    () => resolve(),
                    (err) => reject(err)
                );
            } else {
                resolve();
            }
        });
    };

    const loadTolleranza = (cache: CachePresenze, idTabella: number): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            if (idTabella === null || idTabella === 0) {
                resolve();
            } else if (cache.getTabellaTolleranza(idTabella)) {
                resolve();
            } else {
                showLog && console.log("loadTolleranza INIZIO");
                getTabellaTolleranza({idAziendaTabelle: cache.idAziendaTabelle, idTabella, token,}).then(
                    (data) => {
                        cache.tabelleTolleranza.push(data);
                        showLog && console.log("loadTolleranza FINE");
                        resolve();
                    },
                    (err) => {
                        showError(err);
                        reject(err);
                    });
            }
        });
    };

    const loadFascia = (cache: CachePresenze, idTabella: number): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            if (idTabella === null || idTabella === 0) {
                resolve();
            } else if (cache.getTabellaFasceOrarie(idTabella)) {
                resolve();
            } else {
                showLog && console.log("loadFascia INIZIO");
                getTabellaFasceOrarie({idAziendaTabelle: cache.idAziendaTabelle, idTabella, token,}).then(
                    (data) => {
                        cache.tabelleFasceOrarie.push(data);
                        showLog && console.log("loadFascia FINE");
                        resolve();
                    },
                    (err) => {
                        showError(err);
                        reject(err);
                    });
            }
        });
    };

    const loadCalendario = (cache: CachePresenze, idTabella: number, anno: number): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            if (idTabella === null || idTabella === 0) {
                resolve();
            } else if (cache.getCalendario(idTabella, anno)) {
                resolve();
            } else {
                showLog && console.log("loadCalendario INIZIO");
                getCalendarioChiusure({idAziendaTabelle: cache.idAziendaTabelle, idTabella, anno, token,}).then(
                    (data) => {
                        cache.calendari.push(data);
                        showLog && console.log("loadCalendario FINE");
                        resolve();
                    },
                    (err) => {
                        showError(err);
                        reject(err);
                    });
            }
        });
    };

    const loadTurno = (idAziendaTabelle: number, codTurno: number): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            const cache = getCache(idAziendaTabelle);
            if (!cache || codTurno === null || codTurno === 0) {
                resolve();
            } else if (cache.getTurno(codTurno)) {
                resolve();
            } else {
                showLog && console.log("loadTurno INIZIO");
                getTurno({idAziendaTabelle: cache.idAziendaTabelle, view: "Distribuzione", codTurno, token,}).then(
                    (turno) => {
                        cache.turni.push(turno);

                        const requests = [];
                        requests.push(loadArrotondamenti(cache, turno));
                        if (turno.tabelle) {
                            requests.push(loadQualificaEcc(cache, turno.tabelle.idTabEccedentiQuali));
                            requests.push(loadQuantificaEcc(cache, turno.tabelle.idTabEccedentiQuanti));
                            requests.push(loadTurniAlternativi(cache, turno.tabelle.idTabTurniAlt));
                            requests.push(loadTabellaGiustificazioneAuto(cache, turno.tabelle.idTabGiuRicorrenti));
                            requests.push(loadFlex(cache, turno.tabelle.idTabFlex));
                            requests.push(loadTolleranza(cache, turno.tabelle.idTabTolleranza));
                            requests.push(loadFascia(cache, turno.tabelle.idTabFasciaDiurna));
                        }
                        Promise.all(requests).then(
                            () => {
                                showLog && console.log("loadTurno FINE");
                                resolve();
                            },
                            (err) => reject(err)
                        );
                    },
                    (err) => {
                        showError(err);
                        reject(err);
                    });
            }
        });
    };

    const loadTabelleProprieta = (idAziendaTabelle: number, proprieta: LavoratorePresenzeProprietaULRecord[], anno: number): Promise<void> => {

        showLog && console.log("LOADER loadTabelleProprieta INIZIO");
        const tabelleInCaricamento: TabelleInCaricamento = TabelleInCaricamento.factory();

        return new Promise<void>((resolve, reject) => {
            const requests: Promise<void>[] = [];
            // Carica tutte le tabelle necessarie!
            const cache = getCache(idAziendaTabelle);
            if (cache) {
                for (let ind0 = 0; ind0 < proprieta.length; ++ind0) {
                    const propTabelle = [proprieta[ind0].tabelle, proprieta[ind0].tabelleUL];
                    for (let ind1 = 0; ind1 < propTabelle.length; ++ind1) {
                        const tabelle = propTabelle[ind1];
                        if (tabelle !== null) {
                            if (TabelleInCaricamento.addTabella(tabelleInCaricamento, "qualificaEcc", tabelle.idTabEccedentiQuali))
                                requests.push(loadQualificaEcc(cache, tabelle.idTabEccedentiQuali));
                            if (TabelleInCaricamento.addTabella(tabelleInCaricamento, "quantificaEcc", tabelle.idTabEccedentiQuanti))
                                requests.push(loadQuantificaEcc(cache, tabelle.idTabEccedentiQuanti));
                            if (TabelleInCaricamento.addTabella(tabelleInCaricamento, "turniAlternativi", tabelle.idTabTurniAlt))
                                requests.push(loadTurniAlternativi(cache, tabelle.idTabTurniAlt));
                            if (TabelleInCaricamento.addTabella(tabelleInCaricamento, "tabelleGiustificazioneAuto", tabelle.idTabGiuRicorrenti))
                                requests.push(loadTabellaGiustificazioneAuto(cache, tabelle.idTabGiuRicorrenti));
                            if (TabelleInCaricamento.addTabella(tabelleInCaricamento, "flex", tabelle.idTabFlex))
                                requests.push(loadFlex(cache, tabelle.idTabFlex));
                            if (TabelleInCaricamento.addTabella(tabelleInCaricamento, "tolleranze", tabelle.idTabTolleranza))
                                requests.push(loadTolleranza(cache, tabelle.idTabTolleranza));
                            if (TabelleInCaricamento.addTabella(tabelleInCaricamento, "fasce", tabelle.idTabFasciaDiurna))
                                requests.push(loadFascia(cache, tabelle.idTabFasciaDiurna));
                            //requests.push(that.loader.loadFasciaCompetenza(tabelle.idTabFasciaCompetenza));
                        }
                    }
                    //if (TabelleInCaricamento.addTabella(tabelleInCaricamento, 'calendari', proprieta[ind0].idCalendario))
                    requests.push(loadCalendario(cache, proprieta[ind0].idCalendario, anno));
                    requests.push(loadCalendario(cache, proprieta[ind0].idCalendarioWF, anno));
                }
            }

            if (requests.length > 0) {
                Promise.all(requests).then(
                    () => {
                        showLog && console.log("LOADER loadTabelleProprieta FINE");
                        resolve();
                    },
                    (err) => reject(err)
                );
            } else {
                resolve();
            }
        });
    };

    return {getCache, initCache, purgeCache, loadGiustificativiXStatus, loadTabelleProprieta, loadTurno};
}